import { useState, useEffect, createContext, useContext, useCallback } from "react";
import axios from "axios";
import { API } from "../App";

const BrandingContext = createContext(null);

const DEFAULT_BRANDING = {
  white_label: false,
  wl_app_name: "Human-OZ",
  wl_logo_url: "/logo-humanoz.png",
  wl_primary_color: "#059669",
  wl_secondary_color: "#10b981",
};

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(DEFAULT_BRANDING);

  const fetchBranding = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setBranding(DEFAULT_BRANDING);
      return;
    }
    try {
      const res = await axios.get(`${API}/company/white-label`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data && res.data.white_label) {
        setBranding({
          white_label: true,
          wl_app_name: res.data.wl_app_name || "Mi Empresa",
          wl_logo_url: res.data.wl_logo_url || "",
          wl_primary_color: res.data.wl_primary_color || DEFAULT_BRANDING.wl_primary_color,
          wl_secondary_color: res.data.wl_secondary_color || DEFAULT_BRANDING.wl_secondary_color,
        });
      } else {
        setBranding(DEFAULT_BRANDING);
      }
    } catch {
      setBranding(DEFAULT_BRANDING);
    }
  }, []);

  const resetBranding = useCallback(() => {
    setBranding(DEFAULT_BRANDING);
  }, []);

  useEffect(() => {
    fetchBranding();
  }, [fetchBranding]);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "token") fetchBranding();
    };
    window.addEventListener("storage", onStorage);
    const interval = setInterval(() => {
      const token = localStorage.getItem("token");
      if (token && !branding.white_label && branding.wl_app_name === "Human-OZ") {
        fetchBranding();
      }
      if (!token && branding.white_label) {
        setBranding(DEFAULT_BRANDING);
      }
    }, 1000);
    return () => {
      window.removeEventListener("storage", onStorage);
      clearInterval(interval);
    };
  }, [fetchBranding, branding]);

  return (
    <BrandingContext.Provider value={{ branding, fetchBranding, resetBranding }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => {
  const ctx = useContext(BrandingContext);
  if (!ctx) return { branding: DEFAULT_BRANDING, fetchBranding: () => {}, resetBranding: () => {} };
  return ctx;
};
